import React from 'react'
import classnames from 'classnames'

import styles from './ChangeIndicator.module.scss'

const defaultProps = {
  component: 'span'
}

const ChangeIndicator = ({
  children,
  className,
  component: Component,
  positiveIf
}) => (
  <Component
    className={classnames(
      positiveIf ? styles.positive : styles.negative,
      className
    )}
  >
    {children}
  </Component>
)

ChangeIndicator.defaultProps = defaultProps

export default ChangeIndicator
